import { defineMessages } from 'react-intl';

export default defineMessages({
  updateAccountDetailsSuccessMessage: {
    id: 'app.toast.message.updateAccountDetails.success',
    defaultMessage: 'Success! Your company name has been updated.',
  },
  updateAccountDetailsErrorMessage: {
    id: 'app.toast.message.updateAccountDetails.error',
    defaultMessage: "Sorry - we couldn't update your details.",
  },
  singleProductSuccessDeleteMessage: {
    id: 'app.toast.message.deleteProducts.single.success',
    defaultMessage: 'Goodbye! The product has been deleted.',
  },
  multipleProductSuccessDeleteMessage: {
    id: 'app.toast.message.deleteProducts.multiple.success',
    defaultMessage: 'Goodbye! You have deleted {productCount} {productCount, plural, one {product} other {products}}.',
  },
  productErrorDeleteMessage: {
    id: 'app.toast.message.deleteProducts.error',
    defaultMessage: "Sorry - we couldn't delete your {deletedProducts, plural, one {product} other {products}}",
  },
  productErrorUndeleteMessage: {
    id: 'app.toast.message.undeleteProducts.error',
    defaultMessage: "Sorry - we couldn't undo",
  },
  productSuccessUndeleteMessage: {
    id: 'app.toast.message.undeleteProducts.success',
    defaultMessage: 'Product successfully un-deleted',
  },
  productReceiveSuccessMessage: {
    id: 'app.toast.message.productList.success',
    defaultMessage: 'Success. Your products have been loaded.',
  },
  pdfDownloadUnavailable: {
    id: 'app.toast.message.downloadPDF.unavailable',
    defaultMessage: 'Sorry - the PDF proofs for these products are not available.',
  },
  couldNotAddToCart: {
    id: 'app.toast.message.addToCart.couldNotAdd',
    defaultMessage:
      'Sorry - {selectedProducts, plural, one {the product you selected is not} other {none of the {selectedProducts} products you selected are}} available in the current store.',
  },
  addToCartTotalSuccessMessage: {
    id: 'app.toast.message.addToCart.total.success',
    defaultMessage: 'You have added {addedCount} {addedCount, plural, one {product} other {products}} to your cart.',
  },
  addToCartPartialSuccessMessage: {
    id: 'app.toast.message.addToCart.partial.success',
    defaultMessage:
      "You have added {addedCount} {addedCount, plural, one {product} other {products}} to your cart, however {failedCount} {failedCount, plural, one {product} other {products}} couldn't be added.",
  },
  addToCartTotalErrorMessage: {
    id: 'app.toast.message.addToCart.total.error',
    defaultMessage:
      "Sorry the {failedCount, plural, one {product} other {products}} you selected couldn't be added to the cart.",
  },
  addToCartCommonErrorMessage: {
    id: 'app.toast.message.addToCart.common.error',
    defaultMessage:
      "Sorry - we couldn't add {selectedProducts, plural, one {that item} other {those items}} to your cart.",
  },
  renameProductSuccessMessage: {
    id: 'app.toast.message.rename.success',
    defaultMessage: 'Success! Your product name "{name}" has been renamed.',
  },
  pixelSuccessCreate: {
    id: 'app.toast.message.pixel.create.success',
    defaultMessage: 'Success! Your {productType} has been saved to Your Company Products.',
  },
  pixelSuccessUpdate: {
    id: 'app.toast.message.pixel.update.success',
    defaultMessage: 'Success! Your {productType} has been updated.',
  },
  commonError: {
    id: 'app.toast.message.common.error',
    defaultMessage: 'Oh oh… Houston we have a problem.',
  },
  retryingLabel: {
    id: 'app.toast.message.label.retrying',
    defaultMessage: 'trying...',
  },
  successLabel: {
    id: 'app.toast.message.label.success',
    defaultMessage: 'Done!',
  },
  failedLabel: {
    id: 'app.toast.message.label.failed',
    defaultMessage: 'Failed',
  },
  retryLabel: {
    id: 'app.toast.message.label.retry',
    defaultMessage: 'Retry',
  },
  undoLabel: {
    id: 'app.toast.message.label.undo',
    defaultMessage: 'Undo',
  },
  generalErrorReceivedMessage: {
    id: 'app.toast.message.general.error.message',
    defaultMessage: 'Oops! Something went wrong. Please try again.',
  },
  accessoriesAddToCartFailure: {
    id: 'app.toast.message.accessory.addToCart.failure',
    defaultMessage:
      "Sorry, something went wrong and we weren't able to add the product to your cart. Please try again.",
  },
  accessoriesAddToCartNotEnoughStockFailure: {
    id: 'app.toast.message.accessory.addToCart.notEnoughStock',
    defaultMessage:
      "Unfortunately you've added more items than we have available, please choose a lower quantity and try again.",
  },
  accessoriesAddToCartSuccess: {
    id: 'app.toast.message.accessory.addToCart.success',
    defaultMessage: "We've successfully updated your cart.",
  },
  approvalSentSuccessMessage: {
    id: 'app.toast.message.approval.sent.success',
    defaultMessage: "Your product has been submitted for approval – we’ll notify you when it's ready to order.",
  },
  productApprovedSuccessMessage: {
    id: 'app.toast.message.approval.product.approved.success',
    defaultMessage: "You've successfully approved this product.",
  },
  productEditedAndApprovedSuccessMessage: {
    id: 'app.toast.message.approval.product.editedAndApproved.success',
    defaultMessage: "You've successfully edited and approved this product.",
  },
  productDeclinedSuccessMessage: {
    id: 'app.toast.message.approval.product.declined.success',
    defaultMessage: "You've declined this product. We’ll let {employeeName} know.",
  },
});
